
<template>
  <div>
    <div class="mybox">
      <div class="title">季度产量</div>
      <div class="box">
        <QuarterlyOutput />
      </div>
    </div>
    <div class="mybox">
      <div class="title">产能负荷-未来15天</div>
      <div class="box">
        <div id="ps_line1" class="echarts"></div>
      </div>
    </div>
    <div class="mybox">
      <div class="title">单位产品能耗趋势</div>
      <div class="box">
        <div id="ps_bar2" class="echarts"></div>
      </div>
    </div>
    <div class="mybox">
      <div class="title">{{isnews  =='#/home'?'新闻资讯':'新装设备'}}</div>
      <div v-if=" isnews  =='#/home'" class="box">
        <NewList></NewList>
      </div>

      <div v-else  class="box newequipment">
        <div class="title">{{newequipment.title}}</div>
        <div class="text">{{newequipment.text}}<img :src="newequipment.src"></div>
      </div>



    </div>
  </div>
</template>

<script>
let echarts = require("echarts/lib/echarts");

import QuarterlyOutput from '@/components/QuarterlyOutput' //季度产量
import NewList from '@/views/CompanyProfile/NewList' //新闻资讯
import api from "@/apis/appleft";
export default {
  components: {
    NewList,
    QuarterlyOutput,
  },
  data() {
    return {
      isnews:'#/companyprofile',
      //新装设备
      newequipment:{
        title:'',
        text:'',
        src:'',
      },
      lineData1:[
          ['product', ],
          ['1' , ],
          ['2' , ],
          ['3' , ],
          ['4' , ],
          ['5' , ],
          ['6' , ],
          ['7' , ],
          ['8' , ],
          ['9' , ],
          ['10', ],
          ['11', ],
          ['12', ],
          ['13', ],
          ['14', ],
          ['15', ],
      ],
      //单位产品能耗趋势
      tendencyData:[
        // {
        //   name: '产品2',
        //   type: 'bar', barWidth: '12%',
        //   itemStyle: {
        //     normal: {
        //         color: '#fff45c',
        //         barBorderRadius: [12,12,0,0],
        //     }
        //   },
        //   data: [300, 300, 500, 400, 500, 380,400, 500, 500, 500, 500, 450]
        // },
      ],
    }
  },
  // 方法集合
  methods: {
    ps_bar2(){
      let ps_bar2 = echarts.init( document.getElementById('ps_bar2') );
      ps_bar2.setOption({
          color:['#00ccff','#24ffb1','#fff45c','#ff5f8c','#ae74f3',],
          tooltip: { trigger: 'axis',textStyle:{fontSize: this.$echartsFontSize},
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {
              left: 'center', top:8,
              textStyle: {
                  color: "#fff",fontSize:this.$echartsFontSize
              },
              itemWidth: 15,
              itemHeight: 5,
          },
          xAxis: {
              type: 'category',
              axisLabel:{color:'#fff',fontSize:this.$echartsFontSize},
              axisLine:{lineStyle:{color:'#0060a7'}},
              data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
          },
          yAxis: {
              axisLabel:{color:'#ccd0f2',fontSize:this.$echartsFontSize},
              axisLine:{lineStyle:{color:'#0060a7'}},splitNumber:3,
              splitLine:{lineStyle:{color:'#2336ba'}}
          },
          grid: { left: '12%',right:'10%',top:'60px',bottom:'60px'},
          series: this.tendencyData
      })
    },



    ps_line(id, xAxisData,seriesData,){
      let ps_line = echarts.init( document.getElementById(id));
      ps_line.setOption({
        color:['#00ccff','#24ffb1','#fff45c','#ff5f8c','#ae74f3',],

          tooltip: {
            trigger: 'axis',
          },
          legend: {
            left: 'center', top:10,
            textStyle: {
              color: "#fff",fontSize:this.$echartsFontSize
            },
            itemWidth: 25,itemHeight: 10,

            
          },
          grid: {
            left: '12%',
            right: '4%',
            bottom: '12%',

          },

          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: xAxisData,//['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
            axisLabel:{color:'#fff',fontSize:this.$echartsFontSize,lineHeight:34},
            axisLine:{lineStyle:{color:'#0060a7'}}
          },
          yAxis: {
            axisLabel:{color:'#ccd0f2',fontSize:this.$echartsFontSize},
            axisLine:{lineStyle:{color:'#0060a7'}},
            splitLine:{lineStyle:{color:'#2336ba'}}

          },
          series:seriesData
        
      })
    },    
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.isnews = window.location.hash

    console.log(this.isnews);


    //未来15天能耗
    api
      .load({
        params: {
          limit: 100,
          page: 1,
        },
      })
      .then((res) => {
        if (res.code === 10000) {
          if (res.data.list.length) {
            let xAxisData  = ['1','2','3','4','5','6','7','8','9','10','11','12','13','14','15']
            let seriesData = []
            
            for (const iterator of res.data.list) {

              let dataArr = JSON.parse(iterator.data)
              seriesData.push(
                {
                  name: iterator.proName,
                  type: 'line',
                  data: dataArr
                }
              )
            }

            this.ps_line('ps_line1',xAxisData,seriesData)
          }
        } else {
          this.$message.error(res.message)
        }
      })
      //获取新装设备
      api.getNewDev().then(res=>{
        if(res.code==10000){
          let _data = res.data[0]
          this.newequipment.title = _data.devName
          this.newequipment.text = _data.devRemark
          this.newequipment.src = _data.devImg
        }
      })
      //单位产品能耗趋势
      api
        .tendency({
          params: {
            limit: 100,
            page: 1,
          },
        })
        .then((res) => {
          if (res.code === 10000) {
            if (res.data.list.length) {
              let dataArr =  res.data.list
      
              for (const iterator of dataArr) {
                this.tendencyData.push(
                  {
                    name: iterator.proName,
                    type: 'bar', barWidth: '12%',
                    itemStyle: {
                      normal: {
                        // color: '#fff45c',
                        barBorderRadius: [12,12,0,0],
                      }
                    },
                    data: [
                      iterator.oneData,
                      iterator.twoData,
                      iterator.threeData,
                      iterator.fourData,
                      iterator.fiveData,
                      iterator.sixData,
                      iterator.sevenData,
                      iterator.eightData,
                      iterator.nineData,
                      iterator.tenData,
                      iterator.elevenData,
                      iterator.twelveData,
                    ]
                  }
                )
              }
              this.ps_bar2();
            }
          } else {
            this.$message.error(res.message)
          }
        })

  },
}
</script>
<style lang='less' scoped>
  .newequipment{ display: flex; flex-direction: column; padding:.4rem .8rem .8rem;
    .title{ font-size: .8rem; margin: .3rem 0 .6rem; color: #05f8fc; text-overflow:ellipsis; white-space: nowrap; overflow: hidden;}
    .text{ flex: 1; height: 100%; line-height: 1rem; overflow: hidden;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 9; text-overflow:ellipsis; white-space: wrap;text-indent: 1.5rem; padding-right:9.5rem; position: relative;}
    img{ width: 9rem; position: absolute; top:0; right:0; height:100%;}
  }
</style>